import { List } from 'antd';
import styled, { css } from 'styled-components';
import { isMobile } from 'utils';
import { DEVICE } from 'constants/app/breakpoints';

export const ArtistAvatar = styled.div`
  position: absolute;
  border: 5px solid var(--v3-black-0);
  border-radius: 50%;
  width: 120px;
  height: 120px;
`;

export const CardContent = styled.div`
  margin-bottom: 44px;
  position: relative;
  ${ArtistAvatar} {
    position: absolute;
    left: 80px;
    transform: translate(-50%, -50%);
  }
`;

export const ListBlock = styled(List)`
  && {
    width: 60%;
    height: 115px;
    padding: 10px;
    border: 1px solid var(--v3-black-2);
    border-radius: 16px;
    @media screen and ${DEVICE.xl} {
      width: 100%;
    }
    .ant-list-item {
      justify-content: space-between;
      margin: 0 16px;
      padding: 15px 0 14px !important;
      :not(:last-child) {
        border-bottom: 1px solid var(--v3-gray-5) !important;
      }
    }
    .ant-list-item-meta-title {
      margin-bottom: 0;
      font-weight: 450;
      font-size: 16px;
      line-height: 16px;
      color: var(--v3-text-color-secondary) !important;
    }
  }
`;

export const ListItemValue = styled.div`
  font-weight: 450;
  font-size: 16px;
  line-height: 16px;
  color: var(--v3-text-color);
`;

export const ImageWrapper = styled.div`
  height: 333px;
  padding-bottom: 32.94%;
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 36px;
  .ant-image {
    position: absolute;
    inset: 0;
    img {
      height: 100%;
      object-fit: cover;
    }
  }
`;

export const Page = styled.div`
  overflow: auto;
  height: 100%;
`;

export const SkeletonWrapper = styled.div`
  background-color: var(--v3-black-0);
  .ant-skeleton {
    width: 100%;
  }
  .ant-skeleton-image {
    width: 100%;
  }
`;

export const ArtistInfo = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 80px;
  margin-bottom: 80px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
  gap: 10px;
  @media screen and ${DEVICE.xl} {
    flex-direction: column;
  }
`;

export const Info = styled.div`
  width: 50%;
  padding-right: 20px;
  @media screen and ${DEVICE.xl} {
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const WebsiteInfoSocialMediaWrapper = styled.div`
  display: flex;
  padding-top: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

export const SocialMediaLinksWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  ${isMobile() &&
  css`
    gap: 8px;
  `}
`;

export const SocialMediaIconWrapper = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  padding: 3.3px;
  justify-content: center;
  align-items: center;
  gap: 3.3px;
  border-radius: 16.6px;
  && {
    .fill-rect {
      svg {
        rect {
          fill: var(--v3-black-6);
        }
        path {
          fill: var(--v3-black-100);
        }
      }
    }
    .fill-path {
      svg {
        path {
          fill: var(--v3-black-6);
        }
        rect {
          fill: var(--v3-black-100);
        }
      }
    }
  }
  &:hover {
    cursor: pointer;
    .fill-rect {
      svg {
        rect {
          fill: var(--v3-black-15);
        }
        path {
          fill: var(--v3-black-65);
        }
      }
    }
    .fill-path {
      svg {
        path {
          fill: var(--v3-black-15);
        }
        rect {
          fill: var(--v3-black-65);
        }
      }
    }
  }
`;

export const ArtistName = styled.div`
  position: relative;
  font-weight: 700;
  font-size: 32px;
  line-height: 36px;
  color: var(--v3-text-color);
  margin-bottom: 12px;
`;

export const ArtistUsername = styled.div``;

export const Username = styled.div`
  display: inline;
  padding-right: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  background: linear-gradient(90.52deg, #b881ff -8.21%, #6663ff 106.6%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  flex: none;
  order: 0;
  flex-grow: 0;
  @media screen and ${DEVICE.xl} {
    display: block;
    padding-bottom: 12px;
  }
`;

export const RegisteredOn = styled.div`
  display: inline;
  height: 16px;
  font-weight: 450;
  font-size: 14px;
  line-height: 16px;
  color: var(--v3-text-color-secondary);
  flex: none;
  order: 1;
  flex-grow: 0;
`;

export const Description = styled.div`
  position: relative;
  padding-top: 20px;
  font-weight: 450;
  font-size: 16px;
  line-height: 24px;
  color: var(--v3-text-color);
`;

export const Statistics = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
  @media screen and ${DEVICE.xl} {
    width: 100%;
  }
`;
